class DiscountReasonCodeSearchController extends BaseSearchController
	@register()
	@inject 'ReasonCodeRepository',
		'BACKEND_REASON_CODE_ENTITY_TYPE'

	getSearchQuery: ->
		query = @ReasonCodeRepository.createQuery()
		query.criteria('entity_type', '=', @BACKEND_REASON_CODE_ENTITY_TYPE.DISCOUNT)

		return query
